// extracted by mini-css-extract-plugin
export default {"footer":"PlasmicDisclaimer_footer__suL6h","contentWrapper2":"PlasmicDisclaimer_contentWrapper2__UatA5","text":"PlasmicDisclaimer_text__-yVmM"};